import { Component, Inject } from '@angular/core';
import { EligibilitySite } from '../../models/eligibility-site';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { SiteAddress } from '../../models/site-address';
import { CommonModule, DecimalPipe } from '@angular/common';

@Component({
  selector: 'app-site-info-dialog-component',
  imports: [MatDialogModule, CommonModule, DecimalPipe],
  templateUrl: './site-info-dialog-component.html'
})
export class SiteInfoDialogComponent {
  site: EligibilitySite;

  dataFields = [
    { key: 'address_street_number' as keyof SiteAddress, label: 'Numéro voie' },
    { key: 'address_street_name' as keyof SiteAddress, label: 'Nom voie' },
    { key: 'address_line_1' as keyof SiteAddress, label: 'Adresse - Ligne 1' },
    { key: 'address_zip_code' as keyof SiteAddress, label: 'Code postal' },
    { key: 'address_city' as keyof SiteAddress, label: 'Commune' },
    { key: 'coordinates' as keyof SiteAddress, label: 'Coordonnées' },
    { key: 'fibre_building_code' as keyof SiteAddress, label: 'Code immeuble' }
  ];

  constructor(
    private readonly dialogRef: MatDialogRef<SiteInfoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private readonly data: any
  ) {
    this.site = data.site;
  }

  getMethod() {
    switch (this.site.matchedAddressMethod) {
      case 'base_adresse_ftth_coordinates':
        return 'Base Adresse FTTH à partir des coordonnées';
      case 'base_adresse_ftth_address':
        return 'Base Adresse FTTH à partir de l\'adresse';
      case 'address_normalizer_building':
        return 'Address Normalizer à partir du code immeuble';
      case 'base_adresse_nationale_coordinates':
        return 'Base Adresse Nationale à partir des coordonnées';
      case 'base_adresse_nationale_address_fallback':
        return 'Base Adresse Nationale à partir de l\'adresse';
      default:
        return 'Inconnue';
    }
  }

  getType() {
    switch (this.site.matchedAddressType) {
      case 'housenumber':
        return 'Numéro de maison';
      case 'street':
        return 'Voie';
      case 'municipality':
        return 'Commune';
      default:
        return this.site.matchedAddressType;
    }
  }

  getScore() {
    if (this.site.matchedAddressScore) {
      return this.site.matchedAddressScore * 100;
    }

    return 0;
  }
}
